import {
  Dialog,
  DialogActions,
  DialogContentText,
  DialogProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import styled from '@emotion/styled';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';

const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

export interface AnnotationFormVM {
  annotation: string;
  note: string;
}

interface ModalWarningProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  withAnnulment?: boolean;
  onAnnulment?: () => void;
  nameButton?: string;
  exitButton?: string;
}

const ModalWarningComponent = ({
  open,
  onClose,
  message,
  withAnnulment,
  onAnnulment,
  nameButton = 'Ho capito',
  exitButton = 'Annulla',
}: ModalWarningProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione
      </PmiDialogTitle>
      <PmiDialogContent style={{ padding: '30px 24px' }}>
        <DialogContentText key={message} id="alert-dialog-content" sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        {withAnnulment && Boolean(onAnnulment) ? (
          <PmiButton variant="outlined" color="cdmBrand" onClick={onAnnulment}>
            {exitButton}
          </PmiButton>
        ) : undefined}
        <PmiButton variant="outlined" color="cdmBrandThird" onClick={onClose}>
          {nameButton}
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalWarningComponent.displayName = 'Modal Warning component';

const ModalWarning = memo(ModalWarningComponent);

export default ModalWarning;
